import { render } from "./TabShare.vue?vue&type=template&id=ee1b260e"
import script from "./TabShare.vue?vue&type=script&lang=js"
export * from "./TabShare.vue?vue&type=script&lang=js"
script.render = render

export default script